
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/hr-helpdesk",
      function () {
        return require("private-next-pages/solutions/hr-helpdesk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/hr-helpdesk"])
      });
    }
  